
const nth = number => {
	const int = parseInt(number)
	const string = int.toString()
	if (int >= 4 && int <= 19) {
		return 'th'
	} else {
		if (string.endsWith('1')) return 'st'
		if (string.endsWith('2')) return 'nd'
		if (string.endsWith('3')) return 'rd'
		return 'th'
	}
}

const pad = number => (number < 10) ? "0" + number : "" + number

export function dateFormat(string) {
	if (!Date.parse(string)) return ""
	const date = new Date(string)
	const day = date.toLocaleDateString('en-GB', { day: 'numeric' })
	const month = date.toLocaleDateString('en-GB', { month: 'long' })
	const year = date.toLocaleDateString('en-GB', { year: 'numeric' })
	
	return `${day}${nth(day)} ${month} ${year}`
}

export function timeFormat(string) {
	if (!Date.parse(string)) return ""
	const time = new Date(string)
	
	// getUTCHours removes the timezone from the string
	// for time fields, wp returns a full ISO8601 string (with timezone) in the wp-json api
	// we don't need this for time fields
	const hour = time.getUTCHours()
	const minute = time.getUTCMinutes()
	const meridian = hour >= 12 ? 'pm' : 'am'
	return `${hour}:${pad(minute)}${meridian}`
}